import React from "react";
import { Link } from "react-router-dom";
import { SectieKop, LIJST } from "@/components/rust/Rust";

// v19-C5: Vandaag van COO/CEO: één rij per actieve afdeling, met te laat en de stand van het overleg van deze week.
export const AfdelingenBlok = ({ items }) => (items?.length ? (
  <div className="mb-3 md:mb-4" data-testid="vandaag-afdelingen">
    <SectieKop titel="Afdelingen" aantal={items.length} hint="weekoverleg deze week" actie={<Link to="/afdelingen" data-testid="vandaag-afdelingen-link" className="text-xs font-semibold text-zinc-300 hover:text-white">Naar Afdelingen</Link>} />
    <ul className={LIJST}>
      {items.map((a) => (
        <li key={a.id}>
          <Link to={`/afdelingen?afd=${a.id}`} data-testid={`vandaag-afdeling-${a.id}`} className="px-3 py-[9px] text-[13px] flex flex-wrap items-baseline gap-x-3 gap-y-0.5 hover:bg-zinc-50">
            <span className="font-semibold text-zinc-900 min-w-[150px]">{a.naam}</span>
            <span className={`font-mono text-xs ${a.teLaat ? "text-rose-600 font-bold" : "text-zinc-400"}`}>{a.teLaat} te laat</span>
            <span className="text-xs text-zinc-500 ml-auto">overleg deze week: {a.status === "besproken" ? "besproken" : a.status === "nog-niet" ? "nog niet" : a.statusLabel === "overleg vandaag" ? "gepland vandaag" : `gepland ${a.datumLabel}`}</span>
          </Link>
        </li>
      ))}
    </ul>
  </div>
) : null);
